// GET /api/v1/portfolios/memberships/me — portfolios the creator is ON
// (roster membership, not applications). Includes withdrawn rows so the
// page can show them greyed with a "withdrawn" badge.

import { useQuery } from "@tanstack/react-query";

import { attachRequestIdToScope } from "../../lib/api-client";

export type PortfolioMembership = {
  portfolio_id: string;
  title: string;
  theme: string | null;
  kind: string;
  recruiting_status: "recruiting" | "composed" | "stalled" | "retired";
  position_in_portfolio: number;
  withdrawn_at: string | null;
  /** The portfolio's released drop, if any ("active dossier"). */
  drop_id: string | null;
  drop_status: string | null;
};

type MembershipsResponse = {
  data: PortfolioMembership[];
};

async function fetchMemberships(): Promise<PortfolioMembership[]> {
  const response = await fetch("/api/v1/portfolios/memberships/me", {
    credentials: "include",
  });
  attachRequestIdToScope(response);
  if (!response.ok) {
    throw new Error(`Memberships fetch failed (HTTP ${response.status})`);
  }
  const body = (await response.json()) as MembershipsResponse;
  return body.data;
}

export function useMyPortfolioMemberships() {
  return useQuery({
    queryKey: ["creator-portfolios", "memberships"],
    queryFn: fetchMemberships,
    staleTime: 30_000,
    retry: false,
  });
}
